export default {
  name: 'QueryMixin',
/*   props: {
    queryParam: {
      type: Object,
      default: {}
    },
  },
 */
  created() {
    // 通用的查询条件
    // this.queryParam['createTime'] = [moment().startOf('day'), moment().endOf('day')] 
    console.log(this.queryParam)
    let goback = localStorage.getItem('goback');
    let curQueryParam = sessionStorage.getItem('curQueryParam');
    if (goback === "true" &&  curQueryParam){
      this.queryParam = JSON.parse(curQueryParam);
      sessionStorage.setItem('curQueryParam', "");
      // this.$emit('queryData',queryParam);
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log(this.queryParam)
    // if (to.name == 'LogisticsDetail') {
    if (to.name.indexOf('Detail') >= 0) {
      // 跳转为详情页，缓存当前的查询条件
      sessionStorage.setItem('curQueryParam', JSON.stringify(this.queryParam));
    }else{
      this.queryParam = null
      sessionStorage.setItem('curQueryParam', "");
    }
    next();
  },   
}


